module.exports = __webpack_public_path__ + "static-appopensalud/img/bienestar-logo.ee2b06b.png";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/icons/bienestar-logo.png
// module id = 4033
// module chunks = 78